// removed by extract-text-webpack-plugin
module.exports = {"spacer":"styles__spacer___245Ok","line":"styles__line___ZVdhJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DeleteQuotesOnSend/styles.css
// module id = 960
// module chunks = 0